export const environment = {
  production: true,
  version: '4.59.2',
  topdeskUrl: 'https://myservicedesk.simac.nl/tas/secure/mango/incident',
};
